import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-what-winners-say',
  templateUrl: './what-winners-say.component.html',
  styleUrls: ['./what-winners-say.component.scss']
})
export class WhatWinnersSayComponent implements OnInit {
  desktop: any;
  constructor() { }

  ngOnInit() {
      if ( window.innerWidth <=  767 ) {
          this.desktop = 1;
      } else if ( window.innerWidth <= 992 ) {
          this.desktop = 2;
      } else {
          this.desktop = 3;
      }
  }

}
